import { CalendarToday } from '@workwave-tidal/core/icons'
import { preview } from '@/components/form/preview'
import { useOrderViolationTexts } from '@/intl'
import { Box } from '@mui/material'

import { BulkViewData } from '../../hooks/useBulkViewData/types'
import { useTexts } from './hooks/useTexts'

type Props = {
  bulkData: BulkViewData
}

export function Eligibility(props: Props) {
  const {
    bulkData: { eligibility, violations },
  } = props

  const texts = useTexts()
  const { getViolationText } = useOrderViolationTexts()

  const hasViolations = violations.has('ELG')

  return (
    <Box>
      <preview.SectionTitle>{texts.eligibility.label}</preview.SectionTitle>
      <preview.Field label={null}>
        <preview.ViolationContainer
          violation={
            hasViolations ? <preview.ViolationBadge tooltip={getViolationText('ELG')} /> : null
          }
        >
          {eligibility === 'mixed' ? (
            <preview.MixValue />
          ) : (
            <>
              <CalendarToday sx={{ color: t => t.vars.palette.action.active, width: 20 }} />
              {eligibility}
            </>
          )}
        </preview.ViolationContainer>
      </preview.Field>
    </Box>
  )
}
